<template>
  <card
    class="comparison-card"
    :title="
      `Daily totals of suspicious traffic seen coming from ${getNameByType(
        'asn'
      )} compared to ${getNameByType(comparedWith)}`
    "
  >
    <div class="chart-image" v-if="noAccount">
      <img v-lazy="'/static/overview/chart.png'" alt="chart image" />
    </div>
    <ComparisonChart :comparedWith="comparedWith" v-else></ComparisonChart>
  </card>
</template>

<script>
import Card from '../ui/Card';
import ComparisonChart from '../chart/ComparisonChart';
import mixin from '../../utils/mixin';

export default {
  mixins: [mixin],
  props: ['comparedWith'],
  components: {
    Card,
    ComparisonChart
  }
};
</script>

<style scoped lang="scss">
.chart-image {
  img {
    filter: blur(6px);
    pointer-events: none;
  }
}
</style>
